import MuiAppBar from '@mui/material/AppBar'
import {styled} from '@mui/material/styles'
import List from '@mui/material/List'
import Tooltip from '@mui/material/Tooltip'
import {ListItemButton} from '@mui/material'
import PropTypes from 'prop-types'

export const CLOSED_WIDTH = 64
export const OPEN_WIDTH = 240
const PREFIX = 'SideBarComponent'

export const classes = {
  root: `${PREFIX}-root`,
  container: `${PREFIX}-container`,
  logo: `${PREFIX}-logo`,
  subtitle1: `${PREFIX}-subtitle1`,
  subtitle2: `${PREFIX}-subtitle2`,
  drawer: `${PREFIX}-drawer`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  filters: `${PREFIX}-filters`,
  open: `${PREFIX}-open`,
  toggle: `${PREFIX}-toggle`,
  toggleIcon: `${PREFIX}-toggleIcon`,
  collapse: `${PREFIX}-collapse`,
  avatar: `${PREFIX}-avatar`,
  icon: `${PREFIX}-icon`,
  info: `${PREFIX}-info`,
  toggledIcon: `${PREFIX}-toggledIcon`,
  untoggledIcon: `${PREFIX}-untoggledIcon`,
  iconStyle: `${PREFIX}-iconStyle`,
  iconStyle2: `${PREFIX}-iconStyle2`
}

export const CustomAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({theme, open}) => ({
  backgroundColor: theme.palette.hpBaseLighter,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  width: `calc(100% - ${64}px)`,
  ...(open && {
    width: `calc(100% - ${464}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}))
export const MenuPaperpropsValue = {
  elevation: 0,
  sx: {
    overflow: 'visible',
    borderRadius: '4px',
    boxShadow: (theme) => `0px 2px 8px ${theme.palette.hpBlack}`,
    mt: -1.3,
    '&:before': {
      content: '" "',
      display: 'block',
      position: 'absolute',
      bottom: '-20px',
      left: '7px',
      width: '20px',
      height: '21px',
      bgcolor: (theme) => theme.palette.primary.contrastText,
      transform: 'translateY(-50%) rotate(312deg)'
    }
  }
}
export const Root = styled('div')(({theme}) => ({
  [`& .${classes.root}`]: {
    width: '100%'
  },

  [`& .${classes.container}`]: {
    textAlign: 'center',
    width: '100%'
  },

  [`& .${classes.logo}`]: {
    marginBottom: theme.spacing(2)
  },

  [`& .${classes.subtitle1}`]: {
    minWidth: 0,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.h6.fontSize,
    opacity: 0.5,
    color: theme.palette.primary.contrastText
  },

  [`& .${classes.subtitle2}`]: {
    minWidth: 0,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.h6.fontSize,
    opacity: 0.5,
    color: theme.palette.primary.contrastText
  },

  [`& .${classes.drawer}`]: {
    width: CLOSED_WIDTH,
    whiteSpace: 'nowrap',
    zIndex: theme.zIndex.drawer + 1
  },

  [`& .${classes.drawerPaper}`]: {
    overflowX: 'hidden',
    width: CLOSED_WIDTH,
    boxShadow: theme.shadows[1],
    justifyContent: 'space-between',
    backgroundColor: theme.palette.primary.main,
    top: '40px'
  },

  [`& .${classes.filters}`]: {
    zIndex: 1
  },

  [`& .${classes.open}`]: {
    width: OPEN_WIDTH
  },

  [`& .${classes.toggle}`]: {
    height: 32
  },

  [`& .${classes.toggleIcon}`]: {
    minWidth: 0
  },

  [`& .${classes.collapse}`]: {
    justifyContent: 'flex-end'
  },

  [`& .${classes.avatar}`]: {
    position: 'relative',
    left: '-6px'
  },

  [`& .${classes.icon}`]: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.headingLarge?.fontSize
  },

  [`& .${classes.info}`]: {
    position: 'relative',
    left: '2px'
  },

  [`& .${classes.toggledIcon}`]: {
    borderBottom: `2px solid ${theme.palette.hpAccentGreen}`
  },

  [`& .${classes.untoggledIcon}`]: {
    borderBottom: '2px solid transparent'
  },
  [`& .${classes.iconStyle}`]: {
    color: theme.palette.primary.contrastText,
    marginLeft: '-10px',
    fontSize: theme.typography.h1.fontSize
  },
  [`& .${classes.iconStyle2}`]: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.h5.fontSize
  }
}))

export const StyledList = styled(List)(() => ({
  marginBottom: '59px'
}))

const ToBeStyledTooltip = ({className, open, ...props}) => (
  <Tooltip
    {...props}
    open={open}
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -10]
          }
        }
      ]
    }}
    classes={{tooltip: className}}
  />
)

ToBeStyledTooltip.propTypes = {
  className: PropTypes.any,
  open: PropTypes.bool.isRequired
}

export const StyledTooltip = styled(ToBeStyledTooltip)(({theme}) => ({
  borderRadius: '8px',
  backgroundColor: theme.palette.hpBaseDarker,
  opacity: 1
}))

export const StyledDashboardListItemButton = styled(ListItemButton)(({theme}) => ({
  '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus': {
    backgroundColor: theme.palette.primary.dark
  },
  '&.Mui-selected.Mui-focusVisible': {
    backgroundColor: theme.palette.hpBlack
  }
}))

export const StyledUserAppListButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'openUserInfo' && prop !== 'openAppInfo'
})(({theme, openUserInfo, openAppInfo}) => ({
  backgroundColor: openUserInfo || openAppInfo ? theme.palette.hpPrimaryDark : '',
  '&:hover': {
    backgroundColor: openUserInfo || openAppInfo ? theme.palette.hpPrimaryDark : ''
  }
}))
